module.exports = __webpack_public_path__ + "static/media/temperature.3b6bc7cc.svg";